import http from './http' // needs this file in the same directory
// import {The_Ability} from '../store/index'

export default {

  indexV2(filter) {
    let base = process.env.VUE_APP_API_BASE || "/"
    return http({ url: '/api/v2/custom_fields', method: 'get', baseURL: base, params: {...filter} })
  },

  index(filter){
    return http.get(`/custom_fields`, {params: {...filter}});
  },

  show(item_id){
    return http.get(`/custom_fields/`+item_id);
  },

  ghostShow(item_id, filter) {
    return http.get(`/custom_fields/${item_id}/ghost_custom_fields`, {
      params: {
        ...filter
      }
    });
  },

  create(new_item){
    // if (The_Ability.can('create', 'custom_field')){
      return http.post(`/custom_fields`,{
        custom_field:{ 
          main_field_uuid: new_item.main_field_uuid,

          main_field:      new_item.main_field,
          name:            new_item.name,
          fields:          new_item.fields,
          company_id:      new_item.company_id,
          status:          1,
          
          custom_values_attributes: new_item.custom_values_attributes,
        }
      });
    // } else {
    //   return false
    // }
  },

  update(update_item){
    // if (The_Ability.can('update', 'custom_field')){
      return http.put(`/custom_fields/${update_item.id}`,{
        custom_field:{ 
          id: update_item.id,

          main_field: update_item.main_field,
          name:       update_item.name,
          fields:     update_item.fields,
          company_id: update_item.company_id,
          status:     update_item.status,
          
          custom_values_attributes: update_item.custom_values_attributes,
        }
      });
    // } else {
    //   return false
    // }
  },

  updateToDelete(update_item){
    return http.delete(`/custom_fields/${update_item}`);
  },

}